// @flow strict

import { Fragment } from 'react';

const CanvasPage = Fragment;

export default CanvasPage;
